import { HttpClient } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'
import { BehaviorSubject, delay, tap } from 'rxjs'
import { MarketTypeModel } from '../../../core/models/market-type.model'
import { environment } from '../../../../environments/environment'

@Injectable({
  providedIn: 'root',
})
export class MarketTypesService {
  private http = inject(HttpClient)
  private planifyApiUrl = environment.planifyApiUrl

  private marketsTypes = new BehaviorSubject<MarketTypeModel[]>([])

  public marketsTypes$ = this.marketsTypes.asObservable()

  public getMarketsTypes() {
    return this.http
      .get<MarketTypeModel[]>(`${this.planifyApiUrl}/markets-types`)
      .pipe(
        tap((marketsTypes) => {
          this.marketsTypes.next(marketsTypes)
        })
      )
  }
}
